import "./semantic/semantic.min.css";
import './App.css';
import React, {useState} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {Container, Header, Icon, Image, Segment, Step} from 'semantic-ui-react';
import EmailValidation from "./components/EmailValidation";
import LegalTerms from "./components/LegalTerms";
import Photo from "./components/Photo"
import Password from "./components/Password"
import EmailResend from "./components/EmailResend"
import Complete from "./components/Complete"
import DataManager from "./components/DataManager"

function App(props) {

    const getServerURL = () => {

        if (typeof props.serverurl !== "undefined")
        {
            return props.serverurl;
        }
        else
        {
            switch (window.location.hostname)
            {
                case "register.iatfadp.com":
                    return "https://admin.iatfadp.com";
                break;

                case "staging-register.iatfadp.com":
                case "staging-register-new.iatfadp.com":
                    return "https://staging-admin.iatfadp.com";
                break;

                case "localhost":
                case "local-iatf-register.plexuselearning.net":
                case "local-iatf-register-new.plexuselearning.net":
                default:
                    return "https://local-iatf-admin.plexuselearning.net:8085";
                break;
            }
        }


    }
    const dataManager = new DataManager(getServerURL());

    React.useEffect(() => {
        //
    }, []);

    const [step, setStep] = useState("validate");
    const [jwt, setJwt] = useState();
    const [requirePassword, setRequirePassword] = useState();
    const [croppedPhoto, setCroppedPhoto] = useState();

  return (
    <div className="App">
        <ErrorBoundary fallback={<div>An error occurred.  Please refresh the page to try again.</div>}>
            <Container className='topBanner' style={{display: 'table', width: '100%', height: '8.5em', background: 'linear-gradient(to right, #2b49a8, #62d0f1, #ffffff)'}}>
                <div style={{display: 'table-cell', verticalAlign: 'middle', padding: '0.5em'}}><Image src='/images/iatf_logo_reserved.png' style={{display: 'inline', verticalAlign: 'middle'}} width={100} /><Header as="h2" style={{display: 'inline', color: 'white', padding: '0.5em', verticalAlign: 'middle'}}>ADP REGISTRATION</Header></div>
            </Container>
            <Step.Group unstackable widths={4} style={{marginTop: '0px'}}>
                <Step active={step === "validate" || step === "resend"}>
                    <Icon name='mail' />
                    <Step.Content>
                        <Step.Title>Validate</Step.Title>
                        <Step.Description>Confirm your email address</Step.Description>
                    </Step.Content>
                </Step>

                <Step active={step === "terms"}>
                    <Icon name='legal' />
                    <Step.Content>
                        <Step.Title>Agree</Step.Title>
                        <Step.Description>Legal Terms and Conditions</Step.Description>
                    </Step.Content>
                </Step>

                <Step active={step === "photo"}>
                    <Icon name='photo' />
                    <Step.Content>
                        <Step.Title>Photo</Step.Title>
                        <Step.Description>Upload your photo</Step.Description>
                    </Step.Content>
                </Step>
                <Step active={step === "password"}>
                    <Icon name='key' />
                    <Step.Content>
                        <Step.Title>Password</Step.Title>
                        <Step.Description>Pick your personal password</Step.Description>
                    </Step.Content>
                </Step>
            </Step.Group>

            <Segment size='large' padded style={{maxWidth: '1200px', margin: '0 auto'}}>
                {(step === "validate") &&
                    <EmailValidation setStep={setStep} setRequirePassword={setRequirePassword} setJwt={setJwt} dataManager={dataManager}/>
                }
                {(step === "resend") &&
                    <EmailResend setStep={setStep} dataManager={dataManager} />
                }
                {(step === "terms") &&
                    <LegalTerms setStep={setStep} dataManager={dataManager} />
                }
                {(step === "photo") &&
                    <Photo setStep={setStep} requirePassword={requirePassword} setCroppedPhoto={setCroppedPhoto} jwt={jwt} dataManager={dataManager} />
                }
                {(step === "password") &&
                    <Password setStep={setStep} jwt={jwt} croppedPhoto={croppedPhoto} dataManager={dataManager} />
                }
                {(step === "complete") &&
                    <Complete />
                }
            </Segment>
        </ErrorBoundary>
    </div>
  );
}

export default App;
